const dialog = document.getElementById('country-switcher-dialog');
const localizationForm = dialog?.querySelector('.localization-form');
const countrySelect = dialog?.querySelector('.geSelectedCountry');
const closeButton = dialog?.querySelector('.ge-btnClose');

if (dialog && countrySelect) {
  let trigger = null;

  const sortCountryOptions = (select) => {
    const options = Array.from(select.options, (option) => ({
      label: option.text,
      value: option.value,
    }));

    options.sort((a, b) => a.label.localeCompare(b.label));
    select.replaceChildren(
      ...options.map(({ label, value }) => new Option(label, value))
    );
  };

  const syncSelectedCountry = () => {
    sortCountryOptions(countrySelect);

    if (typeof Shopify !== 'undefined' && Shopify.country) {
      countrySelect.value = Shopify.country;
    }
  };

  const openDialog = (opener) => {
    trigger = opener;
    syncSelectedCountry();
    dialog.showModal();
  };

  const closeDialog = () => {
    if (dialog.open) {
      dialog.close();
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('.ge-btn-open[aria-controls="country-switcher-dialog"]');
    if (!opener) return;

    openDialog(opener);
  });

  closeButton?.addEventListener('click', closeDialog);

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      closeDialog();
    }
  });

  dialog.addEventListener('close', () => {
    trigger?.focus();
    trigger = null;
  });

  localizationForm?.addEventListener('submit', (event) => {
    event.preventDefault();

    /* UNCOMMENT THE BELOW CODE WHEN THERE ARE OTHER STORES TO REDIRECT INTO */

    /*****************************************************************************/
    //for example
    /* const countriesStores = [
      {
        countryCode: "DE",
        href: "https://www.some-site-url.de"
      },
    ];

    for (const store of countriesStores) {
      if (countrySelect.value === store.countryCode) {
        window.location.href = store.href;
        return;
      }
    }
  */

    /*****************************************************************************/
    localizationForm.submit();
  });
}
